import {
  IDefaultCsProps,
  TSpacing,
  TSpacingProp,
} from '@/lib/contentstack-sdk/types';

export type TStat = { title: string; subtitle: string };

export enum EStatsListVariants {
  BASIC = 'basic',
  HOME_PLAN = 'home-plan',
}

export type TStatCMS = { heading: string; subtitle: string };

/**
 * Props for the CMS-driven version of the OrStatsList component.
 * Used to map content coming directly from Contentstack.
 */
export interface IOrStatsListCMSProps extends IDefaultCsProps {
  /**
   * Visual variant of the stats list.
   */
  variant?: EStatsListVariants;
  /**
   * Array of stat objects coming from CMS.
   */
  stats: TStatCMS[];
  /**
   * Top/bottom spacing token applied to the component section (e.g. 'sm', 'md', 'lg').
   */
  top_spacing: TSpacingProp;
  bottom_spacing: TSpacingProp;
  /**
   * Option to transform stat subtitles into uppercase.
   */
  useUppercaseInSubtitle?: boolean;
  /**
   * Fixed UID for identifying this as an or-statslist entry in Contentstack.
   */
  _content_type_uid: 'or-statslist';
}

export interface IOrStatsListProps {
  variant?: EStatsListVariants;
  /**
   * Array of parsed stat objects.
   */
  stats: TStat[];
  useUppercaseInSubtitle?: boolean;
  topSpacing?: TSpacing;
  bottomSpacing?: TSpacing;
  /**
   * Whether to display a top/bottom divider line above the section.
   */
  topDivider?: boolean;
  bottomDivider?: boolean;
}
